// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__PRHKV","tab":"ProcedureTabs_tab__1j_tC"};